export default __webpack_public_path__ + "static/media/you and me.06d63ef1.png";